import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import {
  FETCH_FAVORITE_PROFESSIONALS,
  FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION,
  fetchFavoriteProfessionals as _fetchFavoriteProfessionals,
  REMOVE_FAVORITE_PROFESSIONAL,
} from '~/actions';
import useLoading from '~/hooks/useLoading';

const actions = [
  FETCH_FAVORITE_PROFESSIONALS,
  REMOVE_FAVORITE_PROFESSIONAL,
  FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_ACTION,
];

export const useFavoritesList = () => {
  const isInitialized = useRef(false);
  const dispatch = useDispatch();
  const { isLoading } = useLoading(actions);
  const favoriteProfessionals = useAppSelector((state) => state.user.favoriteProfessionals);
  const filter = useAppSelector((state) => state.user.professionalHubFilter);
  const filteredProfessionals = favoriteProfessionals.filter((professional) => {
    if (filter === 'all') return true;
    return (professional as any).professions?.includes(filter);
  });

  const fetchFavoriteProfessionals = useCallback(async () => {
    await dispatch(_fetchFavoriteProfessionals());
    isInitialized.current = true;
  }, [dispatch]);

  return {
    isInitialized: isInitialized.current,
    isLoading,
    isEmpty: !filteredProfessionals?.length,
    isFiltered: filter !== 'all',
    favoriteProfessionals: filteredProfessionals,
    fetchFavoriteProfessionals,
  };
};
